// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"Menu_customMenu__31NEs","navbarHidden":"Menu_navbarHidden__DIhA7"};